"use client";

import type { ForumVote } from "./forum.types";
import { colors, radii } from "@softmax/design-system/tokens.stylex";
import * as stylex from "@stylexjs/stylex";

export function VoteButton({
  direction,
  label,
  vote,
  onVote,
}: Readonly<{
  direction: 1 | -1;
  label: string;
  vote: ForumVote | undefined;
  onVote(direction: 1 | -1): void;
}>) {
  return (
    <button
      type="button"
      aria-label={`${direction === 1 ? "Upvote" : "Downvote"} ${label}`}
      aria-pressed={vote?.value === direction}
      disabled={vote?.busy}
      onClick={() => onVote(direction)}
      {...stylex.props(
        voteStyles.vote,
        vote?.value === direction && voteStyles.selected,
      )}
    >
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        aria-hidden="true"
        {...stylex.props(direction === -1 && voteStyles.triangleDown)}
      >
        <path
          d="M6 2.3l4.3 7.4H1.7z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.3"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}

const voteStyles = stylex.create({
  vote: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 44,
    minHeight: 44,
    padding: 0,
    borderWidth: 0,
    borderStyle: "none",
    backgroundColor: { default: "transparent", ":hover": colors.hover },
    color: colors.muted,
    borderRadius: radii.small,
    cursor: { default: "pointer", ":disabled": "wait" },
    opacity: { default: 1, ":disabled": 0.5 },
    outline: {
      default: "none",
      ":focus-visible": `2px solid ${colors.foreground}`,
    },
    outlineOffset: 2,
  },
  selected: { color: colors.selected, backgroundColor: colors.selectedSurface },
  triangleDown: { transform: "rotate(180deg)" },
});
